<template>
    <div class="stock_warpper">
        <div class="head_warpper">
            <div class="top_cols">
                <el-form :model="form">
                    <el-row :gutter="20">
                        <el-col :span="4" v-if="rkKeyList.some((item) => item.column_status == 1 && item.field == 'barcode')">
                            <el-form-item>
                                <span class="oneLineTxt">{{ rkKeyList.find((item) => item.field == 'barcode').column_name }}:</span>
                                <span class="oneLineTxt">{{ form['barcode'] }}</span>
                            </el-form-item>
                        </el-col>

                        <el-col :span="4" v-if="rkKeyList.some((item) => item.column_status == 1 && item.field == 'counter_no')">
                            <el-form-item>
                                <span class="oneLineTxt">{{ rkKeyList.find((item) => item.field == 'counter_no').column_name }}:</span>
                                <span class="oneLineTxt">{{ form['counter_no'] }}</span>
                            </el-form-item>
                        </el-col>

                        <el-col :span="8" v-if="rkKeyList.some((item) => item.column_status == 1 && item.field == 'instock')">
                            <el-form-item>
                                <span class="oneLineTxt">库存状态：</span>
                                <el-tag class="oneLineTag" v-if="form['instock'] == 1">在库</el-tag>
                                <el-tag class="oneLineTag" type="success" v-if="form['instock'] == 0">已出库</el-tag>
                                <el-tag class="oneLineTag" type="warning" v-if="form['instock'] == 2">在途</el-tag>
                                <el-tag class="oneLineTag" type="warning" v-if="form['instock'] == 3">云展厅下单</el-tag>
                                <el-tag class="oneLineTag" type="danger" v-if="form['instock'] == -1">核销</el-tag>
                                <el-tag class="oneLineTag" type="danger" v-if="form['instock'] == -2">拆卸</el-tag>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <div style="display: flex; flex-wrap: nowrap">
                                <el-dropdown trigger="click" @command="handleCommand" style="margin-right: 10px">
                                    <el-button type="primary"> {{ $t('common.label') }}<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="1">格式1</el-dropdown-item>
                                        <el-dropdown-item command="2">格式2</el-dropdown-item>
                                        <el-dropdown-item command="3">{{ $t('common.export') }}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-input
                                    type="text"
                                    style="width: 70%"
                                    v-model="barcodeNum"
                                    placeholder="请输入条码号"
                                    clearable
                                ></el-input>
                                <el-input
                                    type="text"
                                    style="width: 70%; margin-left: 10px"
                                    v-model="certificateno"
                                    placeholder="请输入证书号"
                                    clearable
                                ></el-input>
                                <el-button type="primary" style="margin-left: 10px" @click="starSearch">{{ $t('common.search') }}</el-button>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="4" v-for="item in rkKeyList" :key="item.field">
                            <template
                                v-if="
                                    item.column_status == 1 &&
                                    item.field != 'barcode' &&
                                    item.field != 'counter_no' &&
                                    item.field != 'instock'
                                "
                            >
                                <el-form-item :label="`${item.column_name}:`">
                                    <span>{{ form[item.field] }}</span>
                                </el-form-item>
                            </template>
                        </el-col>
                    </el-row>
                    <!-- <el-row :gutter="20">
                        <el-col :span="4">
                            <el-form-item>
                                <span class="oneLineTxt">条码号：</span>
                                <span class="oneLineTxt">{{ form.barcode }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-form-item>
                                <span class="oneLineTxt">柜台：</span>
                                <span class="oneLineTxt">{{ form.counter_no }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item>
                                <span class="oneLineTxt">库存状态：</span>
                                <el-tag class="oneLineTag" v-if="form.instock == 1">在库</el-tag>
                                <el-tag class="oneLineTag" type="success" v-if="form.instock == 0">已出库</el-tag>
                                <el-tag class="oneLineTag" type="warning" v-if="form.instock == 2">在途</el-tag>
                                <el-tag class="oneLineTag" type="danger" v-if="form.instock == -1">核销</el-tag>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <div style="display: flex; flex-wrap: nowrap">
                                <el-input
                                    type="text"
                                    style="width: 70%"
                                    v-model="barcodeNum"
                                    placeholder="请输入条码号"
                                    clearable
                                ></el-input>
                                <el-button type="primary" style="margin-left: 10px" @click="starSearch">{{ $t('common.search') }}</el-button>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" v-for="(item, index) in headData" :key="index">
                        <el-col :span="4" v-for="(items, index) in item" :key="items.field">
                            <el-form-item :label="`${items.lable}:`">
                                <span>{{ form[items.field] }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                </el-form>
            </div>
        </div>
        <div class="table1">
            <div class="title">
                <div style="text-align: left; color: #000; font-size: 16px; padding: 6px 0">条码履历</div>
            </div>
            <vxe-table
                border
                stripe
                resizable
                keep-source
                align="center"
                ref="xTable1"
                height="440"
                show-overflow
                highlight-hover-row
                :loading="loading"
                :auto-resize="true"
                :row-class-name="rowChange"
                :data="tableData"
            >
                <vxe-table-column type="seq" field="seq" width="70" title="序号">
                    <template slot-scope="scoped">
                        <span> {{ scoped.row.seq }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="bill_date" title="单据时间"></vxe-table-column>
                <vxe-table-column field="billtype_name" title="单据类型"></vxe-table-column>
                <vxe-table-column title="单号" field="bill_no">
                    <template v-slot="{ row }">
                        <el-button type="text" @click="handleDetails(row)">{{ row.bill_no }}</el-button>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="counter_name" title="柜台"></vxe-table-column>
                <vxe-table-column field="build_date" :title="$t('common.createTime')"></vxe-table-column>
                <vxe-table-column field="build_name" :title="$t('common.creator')"></vxe-table-column>
                <vxe-table-column field="modify_date" :title="$t('common.modifyTime')"></vxe-table-column>
                <vxe-table-column field="modify_name" :title="$t('common.modifier')"></vxe-table-column>
                <template #empty>
                    <span style="color: red">
                        <img src="@/assets/img/dontHave.png" style="width: 200px" />
                    </span>
                </template>
            </vxe-table>
        </div>

        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="dialogFormVisible" width="35%">
            <div class="printBox" id="prints" ref="prints">
                <div v-for="(item, index) in LabelList" :key="index" style="page-break-after: always">
                    <div style="display: flex; align-items: center; justify-content: center">
                        <div style="display: flex; flex-direction: column; transform: rotate(270deg)">
                            <div style="margin-bottom: 15px; line-height: 1">
                                <div style="font-size: 16px; text-align: center">{{ systemSet.company }}</div>
                                <div style="font-size: 16px">{{ item.barcode_name }}</div>
                                <div style="display: flex; font-size: 14px">
                                    <div>总重:{{ item.wgt }}g</div>
                                    <div style="margin-left: 10px">{{ item.specs }}</div>
                                </div>
                                <div style="display: flex; font-size: 14px">
                                    <div>金重:{{ item.gold_wgt }}g</div>
                                    <div style="margin-left: 10px">银重:{{ item.silver_wgt }}g</div>
                                </div>
                                <div style="display: flex; font-size: 14px">
                                    <div>工费:{{ item.salewgt_prc }}/克</div>
                                    <div style="margin-left: 10px">件工费:{{ item.saleqty_prc }}</div>
                                </div>
                                <div style="font-size: 12px">合格证:QB/T1131-20</div>
                                <div style="font-size: 12px">执行标准:GB11887-20</div>
                            </div>
                            <div style="line-height: 1">
                                <div style="font-size: 16px">标签撕毁&emsp;不退不换</div>
                                <div style="font-size: 14px">款&nbsp;号：{{ item.style_no }}</div>
                                <div style="font-size: 14px">证&nbsp;书：{{ item.certificateno }}</div>
                                <div style="text-align: center">
                                    <img
                                        :id="'barcode' + index"
                                        style="
                                            height: 50px;
                                            width: 120px;
                                            margin: 0px;
                                            padding: 0px;
                                            shape-rendering: crispedges;
                                            image-rendering: optimizeQuality; /*改善下载后不会产生锯齿*/
                                            vector-effect: non-scaling-stroke;
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleModify()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/**
 * 条码履历页面（barcoderecord）
 *
 * 功能概述：
 * 1. 根据条码号/证书号查询条码履历数据，展示库存状态及详细信息
 * 2. 以 vxe-table 表格展示条码的历史操作记录（单据时间、类型、单号、柜台等）
 * 3. 支持标签打印（格式1跳转打印页、格式2弹窗生成条码标签、导出Excel）
 * 4. 支持动态列配置（通过 el-drawer 拖拽调整字段的显示/隐藏与顺序）
 * 5. 支持国际化（列名通过 translateColumns 工具函数根据当前语言动态转换）
 *
 * 依赖接口：
 * - apiGetBarcodeHistoryData：根据条码号/证书号查询履历数据
 * - apiGetListCorrespondingData：获取列配置
 * - apiUpdateListCorrespondingData：更新列配置
 * - apiGetBarcodeHistory：获取条码标签数据
 * - apiGetBarcodeHistoryExport：导出条码履历Excel
 */
import {
    apiGetBarcodeHistoryData,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiGetBarcodeHistory,
    apiGetBarcodeHistoryExport
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';
export default {
    name: 'barcoderecord',
    data() {
        return {
            systemSet: '', // 系统设置信息（从 localStorage 读取，用于标签打印时显示公司名等）
            LabelList: {}, // 标签打印数据列表
            dialogFormVisible: false, // 标签打印弹窗控制
            tableData: [], // 履历表格数据
            barcodeNum: '', // 搜索条件 - 条码号
            certificateno: '', // 搜索条件 - 证书号
            form: {}, // 条码详细信息（顶部表单展示数据）
            loading: false, // 表格加载状态
            keyList: [], // 列配置抽屉中的字段列表（用于拖拽排序和显示/隐藏操作）
            drawers: false, // 列配置抽屉显示控制
            direction: 'rtl', // 抽屉弹出方向（从右向左）
            showIndex: null, // 已显示字段列表中当前悬停的索引（用于显示删除按钮）
            optionalIndex: null, // 可选字段列表中当前悬停的索引（用于显示添加按钮）
            refushTable: true, // 表格刷新标志（切换以触发重新渲染）
            rkKeyList: [], // 经过国际化转换后的列配置列表（用于模板渲染）
            originalRkKeyList: [], // 保存原始的列配置数据（包含所有语言，用于语言切换时重新转换）
            keyStatus: '67', // 列配置的业务ID，用于接口请求时标识对应的列配置组
            perData: {}, // 权限数据
            headData: [ // 静态表头字段定义（备用，当前已被动态列配置替代）
                // 分组1：产品基本信息
                [
                    { lable: '产品', field: 'style_no' },
                    { lable: '款式', field: 'style' },
                    { lable: '品牌', field: 'brand' },
                    { lable: '规格', field: 'specs' },
                    { lable: '材质', field: 'material' }
                ],
                // 分组2：数量与重量信息
                [
                    { lable: '数量', field: 'qty' },
                    { lable: '货重', field: 'goods_wgt' },
                    { lable: '金重', field: 'wgt' },
                    { lable: '成色', field: 'alloy' },
                    { lable: '折足重量', field: 'trans_wgt' }
                ],
                // 分组3：主石相关信息
                [
                    { lable: '主石', field: 'mainstone' },
                    { lable: '主石数', field: 'mainstone_qty' },
                    { lable: '主石重', field: 'mainstone_wgt' },
                    { lable: '主石数单价', field: 'mainstone_qty_prc' },
                    { lable: '主石重单价', field: 'mainstone_wgt_prc' },
                    { lable: '主石金额', field: 'mainstone_amt' }
                ],
                // 分组4：入库价格信息
                [
                    { lable: '入库数单价', field: 'inqty_prc' },
                    { lable: '入库重单价', field: 'inwgt_prc' },
                    { lable: '入库附加件工费', field: 'inadd_qtywage' },
                    { lable: '入库附加重工费', field: 'inadd_wgtwage' },
                    { lable: '入库附加工费', field: 'inadd_wage' },
                    { lable: '入库金额', field: 'inamt' }
                ],
                // 分组5：出库价格信息
                [
                    { lable: '出库数单价', field: 'saleqty_prc' },
                    { lable: '出库重单价', field: 'salewgt_prc' },
                    { lable: '出库附加件工费', field: 'saleadd_qtywage' },
                    { lable: '出库附加重工费', field: 'saleadd_wgtwage' },
                    { lable: '出库附加工费', field: 'saleadd_wage' },
                    { lable: '出库金额', field: 'saleamt' }
                ]
            ]
        };
    },
    mounted() {
        // 监听语言变化，语言切换时重新转换列名以适配当前语言
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，基于原始列配置重新转换为新语言的列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    created() {
        // 组件创建时读取系统设置并加载表格数据
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getTable();
    },
    methods: {
        /**
         * 下拉菜单命令处理
         * command=1: 格式1标签打印（跳转打印页）
         * command=2: 格式2标签打印（弹窗生成条码标签）
         * command=3: 导出Excel
         */
        handleCommand(command) {
            if (command == 1) {
                this.labelClick();
            } else if (command == 2) {
                this.labelClick2();
            } else if (command == 3) {
                this.labelClick3();
            }
        },
        // 格式3：导出条码履历为Excel文件
        labelClick3() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                barcode: this.form.barcode,
                is_exports: 1
            };
            apiGetBarcodeHistoryExport(params)
                .then((res) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([res.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.$t('common.label') + '.xlsx'
                    link.click();
                    this.form.is_exports = 0;
                })
                .catch((error) => {
                    console.error('API Request Failed:', error); // 错误处理
                });
        },
        // 格式2打印确认：关闭弹窗并调用打印
        dialogVisibleModify() {
            this.dialogFormVisible = false;
            this.$print(this.$refs.prints);
        },
        // 格式2：弹窗生成条码标签（使用 JsBarcode 生成条形码图片）
        labelClick2() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                barcode: this.form.barcode
            };
            this.dialogFormVisible = true;
            apiGetBarcodeHistory(params).then((res) => {
                if (res.code == 2000) {
                    this.LabelList = res.data.data;
                    for (let index = 0; index < this.LabelList.length; index++) {
                        if (this.LabelList[index].barcode) {
                            this.$nextTick(() => {
                                // 待生成条码的内容
                                // this.LabelList[index].barcode
                                JsBarcode('#barcode' + index, this.LabelList[index].barcode, {
                                    // format: 'EAN13', //选择要使用的条形码类型
                                    width: 5, //设置条之间的宽度
                                    height: 280, //高度
                                    displayValue: true, //是否在条形码下方显示文字
                                    // text: '456', //覆盖显示的文本
                                    // fontOptions: 'bold italic', //使文字加粗体或变斜体
                                    font: '楷体', //设置文本的字体
                                    // textAlign: 'left', //设置文本的水平对齐方式
                                    // textPosition: 'top', //设置文本的垂直位置
                                    textMargin: 20, //设置条形码和文本之间的间距
                                    fontSize: 80 //设置文本的大小
                                    // background: '#eee', //设置条形码的背景
                                    // lineColor: '#2196f3' //设置条和文本的颜色。
                                    // margin: 10 //设置条形码周围的空白边距
                                });
                            });
                        }
                    }
                    // console.log(res.data);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 格式1：标签打印（跳转至打印融合页面）
        labelClick() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                barcode: this.form.barcode
            };
            apiGetBarcodeHistory(params).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 搜索：根据条码号和证书号查询履历数据
        starSearch() {
            if (this.barcodeNum == '' && this.certificateno == '') {
                this.$message.info('请先填写数据再进行搜索');
                return;
            }
            apiGetBarcodeHistoryData({ barcode: this.barcodeNum.trim(), certificateno: this.certificateno.trim() }).then((res) => {
                if (res.code === 2000) {
                    this.tableData = res.data.records;
                    this.form = res.data.barcodes;
                    this.barcodeNum = '';
                    this.certificateno = '';
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 点击单号跳转至对应单据详情页
        handleDetails(row) {
            if (row.allow_use == '0') {
                this.$message.error('暂无权限');
            } else {
                if (row.bill_code) {
                    this.$router.push({
                        path: '/' + row.bill_code,
                        query: {
                            bill_no: row.bill_no
                        }
                    });
                }
            }
        },
        // 表格行序号赋值（通过 row-class-name 回调实现）
        rowChange(row) {
            row.row.seq = row.seq;
        },
        // ========== 列配置相关方法 ==========

        // 打开列配置抽屉，type=1时从当前列配置复制数据
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '20';
            }
            this.drawers = true;
        },

        // 拖拽移动回调（空实现，预留扩展）
        checkMove() {},

        // 列配置项点击：del=隐藏字段，add=显示字段
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        // 取消列配置，关闭抽屉并重新加载表格数据
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        // 获取列配置数据，并将原始数据保存用于语言切换时重新转换
        getTable() {
            apiGetListCorrespondingData({
                id: '67'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        // 确认列配置，将调整后的字段列表提交到后端保存
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                    console.log(this.refushTable, ' this.refushTable');
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
/* ===== 条码履历页面样式（SCSS） ===== */

/* 页面主容器：底部留出操作栏空间 */
.stock_warpper {
    padding-bottom: 65px;
    box-sizing: border-box;
}
/* 头部信息区域 */
.head_warpper {
    box-sizing: border-box;
}
/* 库存项内边距与盒模型 */
.stockB {
    padding: 0 10px;
    box-sizing: border-box;
}
/* 顶部信息行：单行文本与标签样式 */
.top_cols {
    /* 信息文本：大号加粗字体 */
    .oneLineTxt {
        font-size: 20px;
        font-weight: bold;
    }
    /* 库存状态标签：固定宽高居中显示 */
    .oneLineTag {
        width: 45px;
        height: 30px;
        line-height: 30px;
        padding: 0;
        text-align: center;
    }
}
</style>
<style scoped>
/* ===== 条码履历页面样式（普通CSS） ===== */

/* 表格斑马条纹行背景色 */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
/* 表格表头背景色 */
.vxe-table thead {
    background-color: #ecf5ff;
}
/* 表格整体白色背景 */
.vxe-table {
    background: #fff;
}
/* 表格悬停行背景色（含斑马纹行的悬停状态） */
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
/* box1区域内下拉框宽度 */
.box1 .el-select {
    width: 20%;
}
/* 灰度滤镜效果（用于禁用/不可用状态的视觉呈现） */
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
/* 全局下拉框宽度100% */
.el-select {
    width: 100%;
}
/* stock22表格：表头首行背景色（青绿色） */
.stock22 tr.vxe-header--row:first-child {
    background: rgb(64, 128, 128);
    color: #fff;
}
/* stock2222表格：单元格上下内边距 */
.stock2222 .vxe-body--column:not(.col--ellipsis),
.stock2222 .vxe-footer--column:not(.col--ellipsis),
.stock2222 .vxe-header--column:not(.col--ellipsis) {
    padding: 6px 0;
}
/* stock22表格：mini尺寸下行高设置为36px */
.stock22 .vxe-table.size--mini .vxe-body--column.col--ellipsis,
.stock22 .vxe-table.size--mini .vxe-footer--column.col--ellipsis,
.stock22 .vxe-table.size--mini .vxe-header--column.col--ellipsis,
.stock22 .vxe-table.vxe-editable.size--mini .vxe-body--column {
    height: 36px;
}
/* stock22表格：单元格上下内边距 */
.stock22 .vxe-table .vxe-body--column:not(.col--ellipsis),
.stock22 .vxe-table .vxe-footer--column:not(.col--ellipsis),
.stock22 .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 4px 0;
}
/* 响应式适配：小屏幕（<=768px）下的表格和布局调整 */
@media screen and (max-width: 768px) {
    /* 小屏幕下表格单元格内边距调整 */
    .vxe-table .vxe-body--column:not(.col--ellipsis),
    .vxe-table .vxe-footer--column:not(.col--ellipsis),
    .vxe-table .vxe-header--column:not(.col--ellipsis) {
        padding: 5px 0;
    }
    /* 小屏幕下库存内容区改为纵向排列 */
    .stockcon {
        display: flex;
        flex-direction: column;
    }
    /* 小屏幕下stockA区域改为纵向排列 */
    .stockA {
        flex-direction: column;
    }
    /* 小屏幕下stockB区域允许换行 */
    .stockB {
        flex-wrap: wrap;
    }
}
</style>
